import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { getCaptcha, getAppSalt } from 'store/siteConfig'
import { getUUID } from 'utils'
import { encrypt } from 'utils/rsa'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENTS_MESSAGE_PAY = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  SEND_SMS_REQUEST: null,
  SEND_SMS_SUCCESS: null,
}, 'PAYMENTS_MESSAGE_PAY')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      getAppSalt(getUUID(), (saltObj) => {
        const { salt, saltKey } = saltObj
        const { phoneNo, ...restData } = data
        restData.phoneNo = encrypt(phoneNo, salt)
        dispatch(
          callAPI({
            dispatch: dispatch,
            method: 'POST',
            header: {
              'Salt-Key': saltKey,
            },
            body: restData,
            endpoint: 'cgs/personal/smsPay',
            requestAction: PAYMENTS_MESSAGE_PAY.INIT_REQUEST,
            successAction: PAYMENTS_MESSAGE_PAY.INIT_SUCCESS,
            success: (result) => {
              if (result.paymentOrderNo) {
                dispatch(
                  replace(
                    `/payments/result?ft=${restData.paymentToken}&paymentOrderNo=${result.paymentOrderNo}`
                  )
                )
              }
            },
          })
        )
      })
    )
  }
}

export function sendSms(data, callback) {
  return (dispatch) => {
    dispatch(
      getAppSalt(getUUID(), (saltObj) => {
        // 调用接口前先获取盐做手机号加密
        const { salt, saltKey } = saltObj
        const { phoneNo, ...restData } = data
        restData.phoneNo = encrypt(phoneNo, salt)
        dispatch(
          callAPI({
            dispatch: dispatch,
            method: 'POST',
            header: {
              'Salt-Key': saltKey,
            },
            body: restData,
            endpoint: 'cgs/personal/sendPaySms',
            requestAction: PAYMENTS_MESSAGE_PAY.SEND_SMS_REQUEST,
            successAction: PAYMENTS_MESSAGE_PAY.SEND_SMS_SUCCESS,
            success: (result) => {
              // dispatch(getCaptcha())
              typeof callback === 'function' && callback()
            },
            error: () => {
              dispatch(getCaptcha())
            },
          })
        )
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENTS_MESSAGE_PAY.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_MESSAGE_PAY.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_MESSAGE_PAY.SEND_SMS_REQUEST]: (state, action) => state,
  [PAYMENTS_MESSAGE_PAY.SEND_SMS_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentsMessagePay',
    reducerMap: {
      paymentsMessagePayState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
